<script setup>
import { IconKey, IconLogout, IconUserCircle } from '@tabler/icons-vue';
import { useUser } from '@/composables/useUser';
import DropdownItem from '@/components/DropdownItem.vue';

const user = useUser();
</script>

<template>
    <div class="divide-y divide-gray-100">
        <div class="flex flex-col items-start justify-center px-4 py-3">
            <span class="text-sm font-medium">
                {{ user.name }}
            </span>
            <span class="text-xs text-gray-500">
                {{ user.email }}
            </span>
        </div>

        <div class="p-1">
            <DropdownItem
                :href="route('account.profile')"
                :icon="IconUserCircle"
            >
                Account instellingen
            </DropdownItem>
            <DropdownItem
                :href="route('account.security')"
                :icon="IconKey"
            >
                Wachtwoord wijzigen
            </DropdownItem>
        </div>

        <div class="p-1">
            <DropdownItem
                :href="route('logout')"
                method="post"
                as="button"
                type="submit"
                :icon="IconLogout"
            >
                Uitloggen
            </DropdownItem>
        </div>
    </div>
</template>
